import { JsonapiEntity, attribute, entity } from 'jsonapi-transformers';

@entity({ type: 'bookstores' })
export class Bookstore extends JsonapiEntity<Bookstore> {
  @attribute() has_branches: boolean;
  @attribute() is_enabled: boolean;
  @attribute() is_tenant_default: boolean;
  @attribute() label: string;

  get isEnabled(): boolean {
    return this.is_tenant_default || this.is_enabled;
  }
}
